// @flow

import get from 'lodash/get';
import { createSelector } from 'reselect';

import { selectCartConfigurations } from '@gandi/cart';

import type { FullState } from 'src/types';

/**
 * Retrieve the templateId from the cart configurations for a given process/product_type.
 */
export type SelectTemplateIDForCurrentProductsArgs = {
  process: string,
  productType: string,
};

export const selectTemplateIDForCurrentProducts: (
  state: FullState,
  props: SelectTemplateIDForCurrentProductsArgs,
) => ?string = createSelector(
  [(_, props) => props, selectCartConfigurations],
  (props, configurations) =>
    get(
      configurations.filter(
        conf =>
          conf.process === props.process &&
          conf.product_type === props.productType,
      )[0],
      'payload.template_id',
    ),
);
